import { Component } from '@angular/core';
import { GlobalService } from './shared/services/global.service';
import { GlobalLibraryService, EcommerceUtilsService, IdentifierService, MessagingService } from 'ecommerce-jade-group-plugin';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public showPopupCartPreview: boolean = false;
  public showPopupUserLogin: boolean = false;
  public showPopupUserLogged: boolean = false;
  public showInvisibleDiv: boolean = false;
  public showLocationErrorMessage: boolean;

  ngOnInit() {
    this.identifier.GetIdentifier().then((deviceuuid) => {
      this.messagingService.requestPermission(deviceuuid);
      this.messagingService.receiveMessage();
    });
  }
  constructor(
    private globalService: GlobalService,
    private globalLibraryService: GlobalLibraryService,
    private router: Router,
    private identifier: IdentifierService,
    private utils: EcommerceUtilsService,
    private messagingService: MessagingService
  ) {

    this.globalLibraryService.onChangePermissionGeolocation.subscribe(value => this.showLocationErrorMessage = !value);
    this.globalService.onShowInvisibleDiv.subscribe(value => this.showInvisibleDiv = value);
    this.globalService.onToggleVisibilityCartPreviewPopup.subscribe((value) => this.showPopupCartPreview = value);
    this.globalService.onToggleVisibilityUserLoginPopup.subscribe((value) => this.showPopupUserLogin = value);
    this.globalService.onToggleVisibilityUserLoggedPopup.subscribe((value) => this.showPopupUserLogged = value);
  }


  UserLoggedOut() {
    this.globalService.onToggleVisibilityUserLoggedPopup.next(false);
    this.globalService.onClickInvisibleDiv();
    this.router.navigate(['/menu']);
  }

  GoToMyCurrentOrders() {
    this.globalService.onClickInvisibleDiv();
    this.router.navigate(['/ordenes-pendientes']);
  }
  onClickInvisibleDiv() {
    this.globalService.onClickInvisibleDiv();
  }
  GoToCartPage() {
    this.globalService.onToggleVisibilityCartPreviewPopup.next(false);
    this.router.navigate(['/carrito']);
    this.globalService.onClickInvisibleDiv();
  }
  public goToMenu = () => {
    this.router.navigate(['/menu']);
    this.globalService.onClickInvisibleDiv();
  }


  public goToProfile = () => {
    this.router.navigate(['/perfil/0']);
    this.globalService.onClickInvisibleDiv();
  }

  public activateGeolocalization = () => {
    this.utils.GetCurrentLocation().then(() => { }).catch(() => { });
  }
}
